import { connect } from 'react-redux';
import { StoreState } from '../../../reducers';

import SliderEditor from '../../../components/Editor/SliderEditor';

interface SliderEditorOwnProps {
	page: number;
	id: string;
}

const mapStateToProps = (state: StoreState, { page, id }: SliderEditorOwnProps) => {
	const {
		editor: {
			editableSliders,
			activeItem,
			editPanel: { isDisplayed: isEditPanelDisplayed },
		},
	} = state;

	const { isVisible } = editableSliders[page][id];

	return {
		isActive: id === activeItem.id && page === activeItem.page,
		isVisible,
		isEditPanelDisplayed,
	};
};

export default connect(mapStateToProps)(SliderEditor);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/SliderEditor/index.tsx